const suitcase = require("../../../assets/images/categories/trip.png");
const food = require("../../../assets/images/categories/food.png");
const electronic = require("../../../assets/images/categories/electronic.png");
const course = require("../../../assets/images/categories/course.png");
const services = require("../../../assets/images/categories/services.png");
const library = require("../../../assets/images/categories/library.png");
const entertainment = require("../../../assets/images/categories/entertainment.png");
const health = require("../../../assets/images/categories/health.png");
export interface Category {
  category: string;
  region: string;
  discountType: string;
  orderBy: string;
  imgSrc: any;
}
export const categoriesList: Category[] = [
  {
    category: "Viagens",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: suitcase,
  },
  {
    category: "Alimentação",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: food,
  },
  {
    category: "Eletrônicos",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: electronic,
  },
  {
    category: "Cursos e EAD",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: course,
  },
  {
    category: "Serviços",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: services,
  },
  {
    category: "Livraria e Papelaria",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: library,
  },
  {
    category: "Entretenimento",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: entertainment,
  },
  {
    category: "Saúde e Beleza",
    region: "Todas",
    discountType: "Todos",
    orderBy: "popular",
    imgSrc: health,
  },
];
